import * as React from 'react';

const blogIconSmall = (<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_23111_918)">
    <path d="M15.4417 16.1875H7.50391C6.63017 16.1875 5.92188 15.4792 5.92188 14.6055V8.27734C5.92188 7.40361 6.63017 6.69531 7.50391 6.69531H17.418C18.2917 6.69531 19 7.40361 19 8.27734V18.4716C19 18.9414 18.432 19.1767 18.0998 18.8445L15.4417 16.1865" fill="url(#paint0_linear_23111_918)"/>
    <path d="M4.55827 11.9677L1.90021 14.6257C1.56802 14.9579 1 14.7226 1 14.2529V2.58203C1 1.70829 1.70829 1 2.58203 1H15.2383C16.112 1 16.8203 1.70829 16.8203 2.58203V10.3867C16.8203 11.2605 16.112 11.9687 15.2383 11.9687H4.55827" fill="url(#paint1_linear_23111_918)"/>
    <path d="M13.1289 7.80273C12.402 7.80273 11.8105 7.21134 11.8105 6.48438C11.8105 5.75741 12.402 5.16602 13.1289 5.16602C13.8558 5.16602 14.4473 5.75741 14.4473 6.48438C14.4473 7.21134 13.8558 7.80273 13.1289 7.80273Z" fill="url(#paint2_linear_23111_918)"/>
    <path d="M8.91016 7.80273C8.18323 7.80273 7.5918 7.21134 7.5918 6.48438C7.5918 5.75741 8.18323 5.16602 8.91016 5.16602C9.63708 5.16602 10.2285 5.75741 10.2285 6.48438C10.2285 7.21134 9.63708 7.80273 8.91016 7.80273Z" fill="url(#paint3_linear_23111_918)"/>
    <path d="M4.69141 7.80273C3.96448 7.80273 3.37305 7.21134 3.37305 6.48438C3.37305 5.75741 3.96448 5.16602 4.69141 5.16602C5.41833 5.16602 6.00977 5.75741 6.00977 6.48438C6.00977 7.21134 5.41833 7.80273 4.69141 7.80273Z" fill="url(#paint4_linear_23111_918)"/>
    </g>
    <defs>
    <linearGradient id="paint0_linear_23111_918" x1="16.9414" y1="17.0096" x2="1.00446" y2="10.7368" gradientUnits="userSpaceOnUse">
    <stop stop-color="#2744FF"/>
    <stop offset="1" stop-color="#B9D5FF"/>
    </linearGradient>
    <linearGradient id="paint1_linear_23111_918" x1="12.6326" y1="11.1719" x2="-6.2469" y2="-1.97949" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BDD1E7"/>
    <stop offset="1" stop-color="white"/>
    </linearGradient>
    <linearGradient id="paint2_linear_23111_918" x1="14.0322" y1="7.37621" x2="10.7689" y2="6.16772" gradientUnits="userSpaceOnUse">
    <stop stop-color="#2744FF"/>
    <stop offset="1" stop-color="#B9D5FF"/>
    </linearGradient>
    <linearGradient id="paint3_linear_23111_918" x1="9.81348" y1="7.37621" x2="6.55014" y2="6.16772" gradientUnits="userSpaceOnUse">
    <stop stop-color="#2744FF"/>
    <stop offset="1" stop-color="#B9D5FF"/>
    </linearGradient>
    <linearGradient id="paint4_linear_23111_918" x1="5.59473" y1="7.37621" x2="2.33139" y2="6.16772" gradientUnits="userSpaceOnUse">
    <stop stop-color="#2744FF"/>
    <stop offset="1" stop-color="#B9D5FF"/>
    </linearGradient>
    <clipPath id="clip0_23111_918">
    <rect width="18" height="18" fill="white" transform="translate(1 1)"/>
    </clipPath>
    </defs>
    </svg>
    
    );

export default blogIconSmall; 
